import type { AppData } from 'types/documentServices';
import type { Shell } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import type { UninstallAppOptions } from '../services/uninstallService';
import { uninstallApp } from '../services/uninstallService';
import { EditorPlatformHostIntegrationAPI } from '@wix/editor-platform-host-integration-apis';

export default (shell: Shell) => {
  const editorAPI = shell.getAPI(EditorAPIKey);

  const uninstall = (
    appData: AppData,
    shouldShowModal = true,
    options: UninstallAppOptions = {},
  ) => {
    return uninstallApp(editorAPI, appData, shouldShowModal, options);
  };

  const isSilentInstallRunning = (): boolean => {
    const editorPlatformHostIntegrationAPI = editorAPI.host.getAPI(
      EditorPlatformHostIntegrationAPI,
    );

    return editorPlatformHostIntegrationAPI.applications.isSilentInstallRunning();
  };

  const isIntentInstallRunning = (): boolean => {
    const editorPlatformHostIntegrationAPI = editorAPI.host.getAPI(
      EditorPlatformHostIntegrationAPI,
    );

    return (
      editorPlatformHostIntegrationAPI.applications.isIntentInstallRunning?.() ??
      false
    );
  };

  return {
    isSilentInstallRunning,
    isIntentInstallRunning,
    uninstall,
  };
};
